// import { useFetchCalcularValorInstalacion } from "@/shared/actions/erp";
import { useFetchEntidadesFinancieras } from "@/shared/actions/erp";
import { useFetchCooperativa } from "@/shared/actions/erp/cooperativa.actions";
import { TipoFormaPagoEnumChoice } from "@/shared/constants";
import { IFormaPago, IPaymentMethod, PaymentMethodEnum, TipoContratoENUM } from "@/shared/interfaces";
import { useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";

type Props = {
    form: UseFormReturn<IFormaPago & any>
    onChangeData?: (e: any ) => void 
};

const useFormaPago = ({ form, onChangeData }: Props) => {
    const [tipoTarjetaServicio, setTipoTarjeta] = useState<string | null>(null)
    const {
        reset,
    } = form


    //FETCHS
    const { 
        data: dataCooperativa, 
        isLoading: isLoadingCooperativaServicio 
    } = useFetchCooperativa({
        params: {
            entidad_financiera: form.watch("entidad_financiera_aux")!,
            estado: true,
        },
        enabled: !!form.watch("entidad_financiera_aux"),
    });
    const {
        data: dataEntidadFinancieroServicio, 
        isLoading: isLoadingEntidadFinancieroServicio
    } = useFetchEntidadesFinancieras({
        page_size: 600,
        enabled: form.watch('codigo_forma_pago_aux') == PaymentMethodEnum.TARJETA
    })

    //HANDLERS
    const handleFormaPagoServicio = async (e: IPaymentMethod & any) => {
        setTipoTarjeta(null);
        reset({
            ...form.getValues(),
            entidad_financiera_aux: null,
            codigo_forma_pago_aux: "",
            tipo_contrato_aux: "",
            tarjeta_aux: "",
            valor_instalacion_total_aux: "",
            valor_instalacion_aux: "",
            valor_instalacion_iva_aux: "",
            numero_cuenta_aux: "",
            tipo_cuenta_bancaria_aux: "",
            numero_tarjeta_aux: "",
            // observacion_1: "",
        });

        try {
        if (e) {
            console.log("forma_pago_aux:", e);

            if (e.forma_pago == TipoFormaPagoEnumChoice.DEBITO) {
                form.setValue(
                    "entidad_financiera_aux",
                    e.entidad_financiera
                );
            }
            reset({
                ...form.getValues(),
                // no_cobrar: false,
                codigo_forma_pago_aux: e.forma_pago,
                tipo_contrato_aux: e.tipo_contrato ?? TipoContratoENUM.GEDATECU,
                tarjeta_aux: e.tarjeta,
                numero_cuenta_aux: "",
                tipo_cuenta_bancaria_aux: "",
                numero_tarjeta_aux: "",
                tarjeta_fecha_caducidad_aux:
                    e.forma_pago !== PaymentMethodEnum.TARJETA
                    ? null
                    : form.getValues().tarjeta_fecha_caducidad_aux,
            });
        }
        } catch (error) {
        console.log("erro_", error);
        }
    };

    useEffect(() => {
        if (onChangeData) {
            onChangeData(form.getValues());
        }
    }, [form.getValues()]);

  return {
    handleFormaPagoServicio,
    dataCooperativaServicio: dataCooperativa?.data.data || [],
    isLoadingCooperativaServicio,
    tipoTarjetaServicio,
    isLoadingEntidadFinancieroServicio,
    dataEntidadFinancieroServicio,
  };
};

export default useFormaPago;
